import { render, staticRenderFns } from "./FormText.vue?vue&type=template&id=83e13926&scoped=true"
import script from "./FormText.vue?vue&type=script&lang=js"
export * from "./FormText.vue?vue&type=script&lang=js"
import style0 from "./FormText.vue?vue&type=style&index=0&id=83e13926&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e13926",
  null
  
)

export default component.exports